import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class MedicoServices{
  constructor(public http: HttpClient){}
  
}


